<div class="row">
  @if (ibans && ibans.length > 0) {
    <div class="col col-xs-12 col-sm-12 col-md-12">
      <pr-input-column label="Iban existant" [derrors]="derrors">
        <mat-select
          formControlName="iban"
          (selectionChange)="onIbanSelectionChange($event)"
        >
          @for (ib of ibans; track ib) {
            <mat-option [value]="ib.iban">
              {{ ib.holder }} - {{ ib.bankName }} - {{ ib.iban }}
            </mat-option>
          }
        </mat-select>
      </pr-input-column>
    </div>
  }
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="Titulaire" [derrors]="derrors">
      <input formControlName="holder" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="Domiciliation bancaire" [derrors]="derrors">
      <input formControlName="bankName" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="BIC" [derrors]="derrors">
      <input formControlName="bic" type="text" />
    </pr-input-column>
  </div>
  <div class="col col-xs-12 col-sm-12 col-md-12">
    <pr-input-column label="IBAN" [derrors]="derrors">
      <input
        mask="AA00 AAAA AAAA AAAA AAAA AAAA AAAA AAAA AA"
        [showMaskTyped]="true"
        formControlName="iban"
        type="text"
      />
    </pr-input-column>
  </div>
</div>
